import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const SearchPartDetailsPage = () => {
  const history = useHistory();
  const match = useRouteMatch<{ partId: string }>();

  useEffect(() => {
    if (match.isExact) {
      const { partId } = match.params;
      history.push(`/app/searchParts/${partId}/stock`);
    }
  }, [match]);

  return null;
};

export default SearchPartDetailsPage;
